import { TipoIntervento, DestinatarioMatricola } from '../core-assistenza/models';

export enum StatoChiamata {
    Inviato = 1,
    PresoInCarico = 2,
    InCorso = 3,
    Chiuso = 4,
    Rifiutato = 5,
    AttesaRicambi = 6,
}

export enum StatoFiltroChiamate {
    Aperta = 0,
    Inviato = 1,
    PresoInCarico = 2,
    InCorso = 3,
    Chiuso = 4,
    Rifiutato = 5,
    AttesaRicambi = 6,
}

export interface TipoRichiesta {
    idTipoRichiesta: string,
    descrizione: string
}

export interface ChiamataAttiva {
    idChiamata: string,
    data: Date,
    userName: string,
    tipoRichiesta: string,
    descrizioneAggiuntiva: string,
    stato: number
}

export interface TipiRichiestaRiepiloghiSpecifica {
    tipiRichiesta: ReadonlyArray<TipoRichiesta>,
    chiamateAttive: ReadonlyArray<ChiamataAttiva>
}

export interface Chiamata {
    idChiamata: string,
    numeroMacchina: string,
    codice: string,
    ubicazione: string,
    descrizione: string,
    numero: number,
    data: Date,
    tipoIntervento: TipoIntervento,
    stato: StatoChiamata,
    userName: string,
    tipoRichiesta: string,
    descrizioneAggiuntiva: string,
    motivoRifiuto: string,
    referente: string,
    appuntamento: Date | null,
    idArchivio: string | null,
    fileName: string | null
}

export interface ChiamataNew {
    idSpecifica: string,
    idTipoRichiesta: string,
    tipoIntervento: TipoIntervento,
    descrizioneAggiuntiva: string,
    inviaMail: boolean,
    email: string,
    referente: string,
    allegati?: File[]
}

export interface ChiamateState {
    destinatariMatricole: {
        lista: ReadonlyArray<DestinatarioMatricola>,
        refreshCache: boolean
    },
    tipiRichiestaRiepiloghi: {
        riepiloghi: TipiRichiestaRiepiloghiSpecifica,
        refreshCache: boolean
    },
    chiamateAttive: {
        lista: ReadonlyArray<ChiamataAttiva>,
        refreshCache: boolean
    },
    chiamate: {
        lista: ReadonlyArray<Chiamata>,
        page: number,
        pageSize: number,
        itemsCount: number,
        refreshCache: boolean
    }
}